module.exports = __webpack_public_path__ + "media/limitations/garagedescuadrado-ae32ef05.png";